import Vue from 'vue'
import Vue2Shepherd from 'vue2-shepherd'
Vue.use(Vue2Shepherd)
require('vue2-shepherd/dist/shepherd.css')
require('./style.css')
